import React from "react";
import PropTypes from "prop-types";
import { WizardButtonPanel } from "../../../../components/Buttons";

import { connect } from "react-redux";
import {
  saveDebitorOrderInShoppingCart,
  updateOrderDebitor,
} from "../../actions";
import DebitorOrderOverview from "../../components/DebitorOrderOverview";
import { isResourceReadable } from "../../../Permissions/actions";
import { Resources } from "../../../Permissions";

const mapStateToProps = (state) => {
  return {
    permissions: state.permissions.permissionGroup.admindataaccess,
    debitorOrder: state.modem.shoppingCart,
    selectedDebitor: state.modem.selectedDebitor,
    newModems: state.modem.newModems,
    orderDebitorDetails: state.modem.orderDebitorDetails,
  };
};
const mapDispatchToProps = (dispatch) => ({
  saveDebitorOrder: (...args) =>
    dispatch(saveDebitorOrderInShoppingCart(...args)),
  updateOrderDebitor: (...args) => dispatch(updateOrderDebitor(...args)),
});

class OrderOverview extends React.Component {
  static propTypes = {
    // mapped from state
    permissions: PropTypes.shape({}),
    debitorOrder: PropTypes.object,
    selectedDebitor: PropTypes.object,
    newModems: PropTypes.array,
    orderDebitorDetails: PropTypes.object,
    // actions
    saveDebitorOrder: PropTypes.func.isRequired,
    updateOrderDebitor: PropTypes.func.isRequired,
    // passed by parent
    match: PropTypes.object,
    history: PropTypes.object,
    cancelOrder: PropTypes.func,
    className: PropTypes.string,
  };
  static defaultProps = {
    className: "",
    rows: 12,
  };
  openDebitors = () => {
    const { history, match } = this.props;
    const id = match.params.id;
    history.replace(`/wizard/shop/bestellung/modem/${id}/debitoren`);
  };
  openCatalog = () => {
    const { history, match } = this.props;
    const id = match.params.id;
    history.replace(`/wizard/shop/bestellung/modem/${id}/katalog`);
  };
  onSave = () => {
    const { debitorOrder, saveDebitorOrder } = this.props;
    saveDebitorOrder(debitorOrder, this.openDebitors);
  };
  onUpdate = () => {
    const { newModems, selectedDebitor, updateOrderDebitor } = this.props;
    updateOrderDebitor(
      { debitor: selectedDebitor, modems: newModems },
      this.openDebitors,
    );
  };
  isDebitorComplete = (flag) => {
    this.btnPanel && this.btnPanel.disableBtn("next", !flag);
  };
  render() {
    const {
      className,
      permissions,
      selectedDebitor,
      newModems,
      orderDebitorDetails,
      cancelOrder,
      rows,
    } = this.props;
    const canReadAdminData = isResourceReadable(
      Resources.AdminDataAccess,
      permissions,
    );
    let modems = [];
    let onNext = null;
    let onPrevious = this.openCatalog;
    let disableIfAbsent = true;

    // order
    console.log("OrderOverview.render()", selectedDebitor, orderDebitorDetails);
    if (!selectedDebitor || !orderDebitorDetails) {
      return null;
    }
    // opening a locked order
    if (
      !canReadAdminData &&
      orderDebitorDetails &&
      orderDebitorDetails.modems &&
      orderDebitorDetails.modems.length > 0 &&
      orderDebitorDetails.modems[0].status_id !== undefined &&
      orderDebitorDetails.modems[0].status_id !== 1
    ) {
      console.log("<<: Viewing a locked order:", orderDebitorDetails);
      modems = orderDebitorDetails.modems.map((item, index) => ({
        ...item,
        index,
      }));
      onPrevious = this.openDebitors;
      disableIfAbsent = false;
    } else {
      console.log("<<: Viewing an editable order:", newModems);
      // newModems must be set by previous page (ModemCatalog)
      if (!newModems) {
        return null;
      }
      modems = newModems;
      onNext = this.onUpdate;
    }
    // const approvedColumn = (selectedDebitor.status_id > 2) && (<Column field="approved" header="Freigegeben" className="alg-center"/>);
    return (
      <div className={`modem-shopping-cart clearfix`}>
        <DebitorOrderOverview
          className={className}
          title="Debitor Übersicht"
          hideDebitorSubtitle
          debitor={selectedDebitor}
          modems={modems}
          showApproved={selectedDebitor.status_id > 2}
        />
        <WizardButtonPanel
          ref={(ref) => (this.btnPanel = ref)}
          className="margin-big-top w3-border pad-big w3-light-grey"
          onPrevious={onPrevious}
          onNext={onNext}
          onCancel={cancelOrder}
          nextLabel="Speichern"
          disableIfAbsent={disableIfAbsent}
          nameSuffix="ModemOrder"
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderOverview);
